import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function TelegramWidget() {
  const navigate = useNavigate();

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4">

      {/* Telegram Button */}
      <a
        href="https://t.me/yar_22"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-black text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:bg-[#1B3BA0] transition-colors group"
        aria-label="Написать в Telegram"
      >
        <MessageCircle className="w-6 h-6 relative z-10" />
        <div className="absolute inset-0 rounded-full bg-black animate-ping opacity-20 group-hover:bg-[#1B3BA0]" />
        <div className="absolute inset-0 rounded-full bg-black animate-pulse opacity-40 group-hover:bg-[#1B3BA0]" />
      </a>
    </div>
  );
}

export default TelegramWidget;